/** @format */

// sets the permissions
// has checkboxes

import React, { useState, useEffect, Fragment } from "react";
import { ToastContainer, toast } from "react-toastify";
import "../App.css";
import logoHead from "./logo/cder_logo.png";

import { BrowserRouter as Router, Link, Route, Routes } from "react-router-dom";

import { EmpPrivConfig } from "./emp-priv-config";
import { DocConfig } from "./doc-config";
import { PositionsSubmit } from "./positions_submit";
import { SetApprovers } from "./setApprovers";
import { AddDepartments } from "./add_departments";
import { AddStructures } from "./add_structures";

export const Admin = ({ setAuth }) => {
  const [name, setName] = useState("");

  async function getName() {
    try {
      const resp = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/dashboard`,
        {
          method: "GET",
          headers: { token: localStorage.token },
        }
      );
      const parsRes = await resp.json();
      // console.log(parsRes);

      setName(parsRes.emp_name);
    } catch (err) {
      console.error(err.message);
    }
  }

  useEffect(() => {
    getName();
    setAuth(true);
  }, []);

  const logout = (e) => {
    e.preventDefault();
    localStorage.removeItem("token");
    setAuth(false);
    toast("Déconnecté");
  };

  return (
    <Fragment>
      {/* <div className=" m-0  text-white main-banner">
        <div className="head-banner-logo">
          <img src={logoHead} alt="logoHead" />
        </div>
        <div className="banner-text-1">
          <p>
            Popular Democratic Republic of Algeria Ministry of Higher Education
            & Scienth1ific Research General Directorate for Scientific Research
            and Technological Development
          </p>
        </div>
        <div className="banner-text-2">
          <h5>Renewable Energy Development Center</h5>
        </div>
      </div> */}

      <div className="topnav">
        <div className="left-menu-admin">
          <Link to="/dashboard">Accueil</Link>
          <Link to="/admin/emp-priv-config">
            Gestion des privileges des employees
          </Link>
          <Link to="/admin/doc-config">
            Configurer les approbateurs des documents
          </Link>
          <Link to="/admin/pos-submit">Positions et Fonctions</Link>
          <Link to="/admin/set-approvers">Designer les approbateurs</Link>
          <Link to="/admin/add_structures">Configurer les structures</Link>
        </div>
        <div className="right-menu">
          <button className="dash-logout" onClick={(e) => logout(e)}>
            se Déconnecter
          </button>
          <div className=" relative flex items-center justify-center float-right pr-3">
            <span className="p-3 text-white">{name}</span>
          </div>
        </div>
      </div>

      <div className="admin-console">
        <Routes>
          <Route
            path="emp-priv-config/"
            element={<EmpPrivConfig setAuth={setAuth} />}
          />
          <Route path="doc-config/" element={<DocConfig setAuth={setAuth} />} />
          <Route
            path="pos-submit/"
            element={<PositionsSubmit setAuth={setAuth} />}
          />
          <Route
            path="set-approvers/"
            element={<SetApprovers setAuth={setAuth} />}
          />
          {/* <Route
            path='add_departments/'
            element={<AddDepartments setAuth={setAuth} />}
          /> */}
          <Route
            path="add_structures/"
            element={<AddStructures setAuth={setAuth} />}
          />
        </Routes>

        {/* <EmpPrivConfig setAuth= {setAuth}/>
          <DocConfig setAuth= {setAuth}/> */}
      </div>

      <ToastContainer />
    </Fragment>
  );
};
